// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskModal_modalContent__AqhUJ {
  width: min(920px, 96vw);
  max-width: 920px;
  margin: auto;
  padding: 24px;
  border-radius: 14px;
  background-color: var(--cl-surface);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  max-height: 86vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.TaskModal_modalContent__AqhUJ h2 {
  margin-bottom: 14px;
  text-align: left;
  font-size: 22px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI {
  margin-bottom: 12px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI label {
  display: block;
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 13px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI input,
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--cl-border);
  border-radius: 10px;
  font-size: 14px;
  resize: vertical;
  min-height: 44px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI input.TaskModal_errorInput__wW0G4,
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI textarea.TaskModal_errorInput__wW0G4 {
  border-color: #ff4d4f;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI textarea {
  min-height: 110px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_fileHint__3VVbI {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_imagePreview__ZvGXT {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_imagePreview__ZvGXT img {
  max-width: min(280px, 100%);
  border-radius: 10px;
  border: 1px solid var(--cl-border);
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_imagePreview__ZvGXT a {
  font-size: 12px;
  color: #0f62fe;
  word-break: break-all;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_clipboardPasteZone__\\+7fFS {
  margin-top: 10px;
  min-height: 76px;
  padding: 14px 16px;
  border: 1px dashed var(--cl-border);
  border-radius: 10px;
  background: rgba(15, 98, 254, 0.04);
  color: var(--cl-text, #1f2937);
  font-size: 13px;
  line-height: 1.45;
  cursor: text;
  outline: none;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_clipboardPasteZone__\\+7fFS:focus {
  border-color: #0f62fe;
  box-shadow: 0 0 0 3px rgba(15, 98, 254, 0.12);
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_clipboardPasteZone__\\+7fFS:empty::before {
  content: attr(data-placeholder);
  color: #6b7280;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_errorMessage__skehK {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 6px;
  display: block;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_checkboxLabel__BYv7Y {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  margin-bottom: 0;
  color: #9f1239;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_checkboxLabel__BYv7Y input {
  width: 18px;
  min-height: 18px;
  padding: 0;
  accent-color: #be185d;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_checkboxLabel__BYv7Y span {
  line-height: 1.3;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_checkboxLabel__BYv7Y .TaskModal_checkboxText__jYOfN {
  display: grid;
  gap: 5px;
  min-width: 0;
}
.TaskModal_modalContent__AqhUJ .TaskModal_field__7uSAI .TaskModal_checkboxLabel__BYv7Y .TaskModal_priorityNote__oLzQt {
  align-self: flex-start;
  padding: 3px 8px;
  border: 1px solid #fecdd3;
  border-radius: 999px;
  background: #fff1f2;
  color: #be123c;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button {
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  min-height: 44px;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button:first-of-type {
  background-color: #007bff;
  color: white;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button:first-of-type:hover {
  background-color: #0056b3;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button:last-of-type {
  background-color: #6c757d;
  color: white;
}
.TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button:last-of-type:hover {
  background-color: #5a6268;
}

/* === react-select inside modal: make it taller and touch friendly === */
.react-select__control {
  min-height: 44px;
  border-radius: 10px;
}

.react-select__menu {
  z-index: 9999;
}

/* Mobile: bottom-sheet/fullscreen */
@media (max-width: 768px) {
  .TaskModal_modalContent__AqhUJ {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    max-height: none;
    margin: 0;
    border-radius: 16px 16px 0 0;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 14px;
    padding-top: 60px;
  }
  .TaskModal_modalContent__AqhUJ h2 {
    font-size: 16px;
  }
  .TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A {
    position: sticky;
    bottom: 0;
    background: var(--cl-surface);
    padding-top: 10px;
    padding-bottom: 6px;
  }
  .TaskModal_modalContent__AqhUJ .TaskModal_buttonsContainer__Vb6\\+A button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Task/TaskModal.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,2CAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAEI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAN;AAGI;;EAEE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADN;AAGM;;EACE,qBAAA;AAAR;AAII;EACE,iBAAA;AAFN;AAKI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAHN;AAMI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAJN;AAMM;EACE,2BAAA;EACA,mBAAA;EACA,kCAAA;AAJR;AAOM;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AALR;AASI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,mCAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAPN;AASM;EACE,qBAAA;EACA,6CAAA;AAPR;AAUM;EACE,+BAAA;EACA,cAAA;AARR;AAYI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAVN;AAaI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAXN;AAaM;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;AAXR;AAcM;EACE,gBAAA;AAZR;AAeM;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAbR;AAgBM;EACE,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAdR;AAmBE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAjBJ;AAmBI;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAjBN;AAmBM;EACE,mBAAA;EACA,aAAA;AAjBR;AAoBM;EACE,yBAAA;EACA,YAAA;AAlBR;AAoBQ;EACE,yBAAA;AAlBV;AAsBM;EACE,yBAAA;EACA,YAAA;AApBR;AAsBQ;EACE,yBAAA;AApBV;;AA2BA,yEAAA;AACA;EACE,gBAAA;EACA,mBAAA;AAxBF;;AA0BA;EACE,aAAA;AAvBF;;AA0BA,oCAAA;AACA;EACE;IACE,WAAA;IACA,kCAAA;IACA,gBAAA;IAEA,SAAA;IAEA,4BAAA;IAEA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IAEA,aAAA;IACA,iBAAA;EA3BF;EA8BA;IACE,eAAA;EA5BF;EA+BA;IACE,gBAAA;IACA,SAAA;IACA,6BAAA;IACA,iBAAA;IACA,mBAAA;EA7BF;EAgCA;IACE,WAAA;EA9BF;AACF","sourcesContent":[".modalContent {\n  width: min(920px, 96vw);\n  max-width: 920px;\n  margin: auto;\n  padding: 24px;\n  border-radius: 14px;\n  background-color: var(--cl-surface);\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);\n  max-height: 86vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  box-sizing: border-box;\n\n  h2 {\n    margin-bottom: 14px;\n    text-align: left;\n    font-size: 22px;\n  }\n\r\n  .field {\r\n    margin-bottom: 12px;\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 6px;\r\n      font-weight: 700;\r\n      font-size: 13px;\r\n    }\r\n\r\n    input,\r\n    textarea {\r\n      width: 100%;\r\n      padding: 10px 12px;\r\n      border: 1px solid var(--cl-border);\n      border-radius: 10px;\r\n      font-size: 14px;\r\n      resize: vertical;\r\n      min-height: 44px;\r\n\r\n      &.errorInput {\r\n        border-color: #ff4d4f;\r\n      }\r\n    }\r\n\r\n    textarea {\n      min-height: 110px;\n    }\n\n    .fileHint {\n      display: block;\n      margin-top: 6px;\n      font-size: 12px;\n      color: #6b7280;\n    }\n\n    .imagePreview {\n      margin-top: 10px;\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      img {\n        max-width: min(280px, 100%);\n        border-radius: 10px;\n        border: 1px solid var(--cl-border);\n      }\n\n      a {\n        font-size: 12px;\n        color: #0f62fe;\n        word-break: break-all;\n      }\n    }\n\n    .clipboardPasteZone {\n      margin-top: 10px;\n      min-height: 76px;\n      padding: 14px 16px;\n      border: 1px dashed var(--cl-border);\n      border-radius: 10px;\n      background: rgba(15, 98, 254, 0.04);\n      color: var(--cl-text, #1f2937);\n      font-size: 13px;\n      line-height: 1.45;\n      cursor: text;\n      outline: none;\n\n      &:focus {\n        border-color: #0f62fe;\n        box-shadow: 0 0 0 3px rgba(15, 98, 254, 0.12);\n      }\n\n      &:empty::before {\n        content: attr(data-placeholder);\n        color: #6b7280;\n      }\n    }\n\n    .errorMessage {\n      color: #ff4d4f;\n      font-size: 12px;\n      margin-top: 6px;\n      display: block;\n    }\n\n    .checkboxLabel {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      min-height: 44px;\n      margin-bottom: 0;\n      color: #9f1239;\n\n      input {\n        width: 18px;\n        min-height: 18px;\n        padding: 0;\n        accent-color: #be185d;\n      }\n\n      span {\n        line-height: 1.3;\n      }\n\n      .checkboxText {\n        display: grid;\n        gap: 5px;\n        min-width: 0;\n      }\n\n      .priorityNote {\n        align-self: flex-start;\n        padding: 3px 8px;\n        border: 1px solid #fecdd3;\n        border-radius: 999px;\n        background: #fff1f2;\n        color: #be123c;\n        font-size: 12px;\n        font-weight: 800;\n        line-height: 1.2;\n      }\n    }\n  }\n\r\n  .buttonsContainer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n    flex-wrap: wrap;\r\n\r\n    button {\r\n      padding: 10px 16px;\r\n      border: none;\r\n      border-radius: 10px;\r\n      cursor: pointer;\n      font-size: 14px;\n      min-height: 44px;\n\n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.65;\n      }\n\n      &:first-of-type {\n        background-color: #007bff;\n        color: white;\n\r\n        &:hover {\r\n          background-color: #0056b3;\r\n        }\r\n      }\r\n\r\n      &:last-of-type {\r\n        background-color: #6c757d;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #5a6268;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* === react-select inside modal: make it taller and touch friendly === */\r\n:global(.react-select__control) {\r\n  min-height: 44px;\r\n  border-radius: 10px;\r\n}\r\n:global(.react-select__menu) {\r\n  z-index: 9999;\r\n}\r\n\r\n/* Mobile: bottom-sheet/fullscreen */\r\n@media (max-width: 768px) {\n  .modalContent {\n    width: 100%;\n    height: calc(var(--vh, 1vh) * 100);\n    max-height: none;\n\r\n    margin: 0;\r\n\r\n    border-radius: 16px 16px 0 0;\r\n\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n\n    padding: 14px;\n    padding-top: 60px;\n  }\n\r\n  .modalContent h2 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .modalContent .buttonsContainer {\r\n    position: sticky;\r\n    bottom: 0;\r\n    background: var(--cl-surface);\n    padding-top: 10px;\r\n    padding-bottom: 6px;\r\n  }\r\n\r\n  .modalContent .buttonsContainer button {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `TaskModal_modalContent__AqhUJ`,
	"field": `TaskModal_field__7uSAI`,
	"errorInput": `TaskModal_errorInput__wW0G4`,
	"fileHint": `TaskModal_fileHint__3VVbI`,
	"imagePreview": `TaskModal_imagePreview__ZvGXT`,
	"clipboardPasteZone": `TaskModal_clipboardPasteZone__+7fFS`,
	"errorMessage": `TaskModal_errorMessage__skehK`,
	"checkboxLabel": `TaskModal_checkboxLabel__BYv7Y`,
	"checkboxText": `TaskModal_checkboxText__jYOfN`,
	"priorityNote": `TaskModal_priorityNote__oLzQt`,
	"buttonsContainer": `TaskModal_buttonsContainer__Vb6+A`
};
export default ___CSS_LOADER_EXPORT___;
